import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { BankingDepositCreateValidationSchema } from '../../schemas/bankingDeposits/create.schema'
import { unFormatCurrency } from '@/common/utils/unFormatters'
import { AxiosResponse } from 'axios'

type UseCreateBankingDepositProps = {
  companyId?: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: ErrorResponse) => void;
}

export const useCreateBankingDeposit = ({
  companyId,
  onSuccess,
  onError,
}: UseCreateBankingDepositProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createBankingDeposit', companyId],
    mutationFn: (form: BankingDepositCreateValidationSchema) => {
      const payload = {
        deposit: {
          requested_total: form.requested_total && unFormatCurrency(form.requested_total),
          payment_method_id: form.payment_method?.id,
          company_id: companyId,
        }
      }

      return privateAxios.post(`/banking/deposits`, payload);
    },
    onSuccess,
    onError,
  });
}
